// extracted by mini-css-extract-plugin
export default {"FolderCrumbFolderName":"FolderCrumb_FolderCrumbFolderName__GJLuX","FolderCrumbRemoveIcon":"FolderCrumb_FolderCrumbRemoveIcon__ERcan"};